/**
 * VehicleResultPage Modal Management Mixin
 *
 * This mixin is SPECIFIC to VehicleResultPage component only.
 * Provides methods for managing modal dialogs (info, enquire now, lease inclusion).
 *
 * All methods are prefixed with "vrpModal_" to indicate their source.
 *
 * Methods provided:
 * - vrpModal_showInfo: Show/hide information modal
 * - vrpModal_showEnquireNow: Show/hide enquire now modal with vehicle data
 * - vrpModal_handleViewShortlist: Navigate to shortlist page/dashboard
 * - vrpModal_handleLeaseInclusionDialog: Show lease inclusion dialog
 */
import {
  GTM_EVENT_NAME_SME_LEASE_CALCULATOR_CAR,
  GTM_EVENT_STAGE_VIEW_SHORTLIST,
  GTM_EVENT_STAGE_VIEW_ENQUIRY,
  GTM_EVENT_VALUES_LEASE_CALCULATOR_CAR
} from '../../utils/constants';
import { serializePairs } from '../../utils/helpers';

export default {
  methods: {
    /**
     * Show/hide information modal
     * @param {Boolean} value - Show (true) or hide (false) modal
     */
    async vrpModal_showInfo(value) {
      if (value) {
        await new Promise((resolve) => {
          setTimeout(() => {
            this.showInformationModal = false;
            resolve();
          }, 10);
        });
      }

      this.showInformationModal = value;
    },

    /**
     * Show/hide enquire now modal with vehicle data
     * Tracks GTM event when showing modal
     * @param {Boolean} value - Show (true) or hide (false) modal
     * @param {Object} vehicle - Vehicle data to display in modal
     */
    async vrpModal_showEnquireNow(value, vehicle = null) {
      if (value) {
        setTimeout(() => {
          this.$gtm.trackEvent({
            event: GTM_EVENT_NAME_SME_LEASE_CALCULATOR_CAR,
            stage: GTM_EVENT_STAGE_VIEW_ENQUIRY,
            data: {
              ...GTM_EVENT_VALUES_LEASE_CALCULATOR_CAR
            }
          });
        });

        await new Promise((resolve) => {
          setTimeout(() => {
            this.showEnquireNowModal = false;
            resolve();
          }, 10);
        });
      }

      if (vehicle) {
        this.enquireNowVehicle = vehicle;
      }

      this.showEnquireNowModal = value;
    },

    /**
     * Navigate to shortlist page or dashboard
     * Tracks GTM event and navigates based on user authentication status
     */
    vrpModal_handleViewShortlist() {
      setTimeout(() => {
        this.$gtm.trackEvent({
          event: GTM_EVENT_NAME_SME_LEASE_CALCULATOR_CAR,
          stage: GTM_EVENT_STAGE_VIEW_SHORTLIST,
          data: {
            ...GTM_EVENT_VALUES_LEASE_CALCULATOR_CAR
          }
        });
      });

      if (this.user === null) {
        const { pair, ...rest } = this.searchOptions; // pair is Array<{make,models}>
        const serializedPair = serializePairs(pair);

        const query = { ...rest };
        if (serializedPair) {
          // only include if non-empty / non-null
          query.pair = serializedPair;
        }

        this.$router.push({ name: 'calculatorShortlists', query });
        return;
      }
      this.$router.push({ name: 'dashboard' });
    },

    /**
     * Show lease inclusion dialog
     */
    vrpModal_handleLeaseInclusionDialog() {
      this.showLeaseInclusion = true;
    }
  }
};
